const {API, graphqlOperation} = require('aws-amplify')
const {makeCsv} = require('@/graphql/queries')
const baseModel = require("../baseModel")



/**
 * 通知用のデータ取得モデルクラス
 */
class CsvInfoMode  {
  /**
   * テナント内の通知リストを取得する
   *
   * @returns 通知リスト
   */
  static async getCsv(_tenantId = null, list) {
    let tenantId = _tenantId
    if (!tenantId) {
      const loginInfo = await UserInfo.getUserInfo()
      if (!loginInfo.group) {
        return null
      }
      tenantId = loginInfo.group
    }
    
    if (!tenantId) {
      return;
    }

    let result = await API.graphql(
      graphqlOperation(makeCsv, {
        pk: tenantId,
        list: list
      })
    );
    if (result) {
      if (result.data) {
        return result.data.makeCsv
      }
    }
  }

}

module.exports = CsvInfoMode
